import aponeo from './aponeo';

export default () => {
  /** Alternative Packungsgrößen auf PDP**/
  $('#productdetail_altsizes').change((event) => {
    window.location.href = $(event.target).find(':selected').data('url');
  });

  /** Anchor on Product Detail Page opens dropdown kundenbewertung (#dropdown-product-info-5) target (only mobile)**/
  $('a[href="#Bewertungen"]').on('click', function () {
    $('#dropdown-product-info-5').collapse('show');
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $('#dropdown-product-info-5').offset().top,
      },
      2000,
    );
  });

  const $productDetailRatingWrapper = $('.product-detail-rating-wrapper');
  if ($productDetailRatingWrapper.length) {
    const labels = [
      'Bitte bewerten Sie das Produkt',
      'Gefällt mir gar nicht',
      'Gefällt mir nicht',
      'Nicht schlecht',
      'Gefällt mir',
      'Gefällt mir sehr',
    ];
    $productDetailRatingWrapper.each((index, element) => {
      const $wrapper = $(element);
      const $rating = $wrapper.find('.product-detail-rating');
      const $stars = $rating.find('.icon');
      const $label = $wrapper.find('.product-detail-rating-label');
      const $input = $wrapper.find('.product-detail-rating-input');

      $stars.each((i, elemI) => {
        $(elemI).on('click mouseenter', () => {
          $stars.removeClass('active');
          $stars.each((j, elemJ) => {
            $(elemJ).addClass('active');
            return j < i;
          });
          $input.val(1 + i);
          $label.text(labels[1 + i]);
        });
      });
    });
  }

  let $productPros = $('.apn-product-pros');
  if ($productPros.length) {
    $('.apn-product-pros-link', $productPros).on('click.mw', (e) => {
      if (window.matchMedia('screen and (max-width: 767px)').matches) {
        e.preventDefault();
      }
    });
  }

  if ($('#apn-product-ratings').length) {
    const sendRpcRequest = (action, id, option, callback) => {
      $.ajax({
        type: 'GET',
        url: '/rpc.php?action=' + action + '&id=' + id + '&option=' + option,
        beforeSend: () => {
          aponeo.showLoadingScreen();
        },
      })
        .done((result) => {
          if (callback) {
            callback(result);
          }
        })
        .always(() => {
          aponeo.hideLoadingScreen();
        });
    };
    // yes/no buttons
    $('#apn-product-ratings .apn-product-detail-rating .rating-info').each((index, element) => {
      const id = $(element).data('rating-id');
      const target = $(element).find('.rating-text');
      const btnUp = $(element).find('.btn-rating-up');
      const btnDown = $(element).find('.btn-rating-down');
      const ratingCallback = (result) => {
        target.text(result);
        btnUp.attr('disabled', 'disabled');
        btnDown.attr('disabled', 'disabled');
      };
      btnUp.on('click', () => {
        sendRpcRequest('productrating', id, 'up', ratingCallback);
      });
      btnDown.on('click', () => {
        sendRpcRequest('productrating', id, 'down', ratingCallback);
      });
    });
    // comment modal form
    $('#apn-product-ratings .apn-product-detail-rating .btn-comment-submit').on('click', (event) => {
      const $element = $(event.target);
      const form = $element.closest('form');
      const modal = $element.parents('.modal:first');
      const errorClass = 'is-invalid';
      $.ajax({
        type: 'POST',
        url: '/rpc.php?action=addProductRatingComment',
        data: form.serialize(),
        beforeSend: () => {
          aponeo.showLoadingScreen();
        },
      })
        .done((result) => {
          aponeo.addNotificationList(result.messages);
          modal.modal('hide');
          aponeo.refreshCaptcha();
          window.scrollTo(0, $('#notification-lines').position().top);
        })
        .fail((xhr) => {
          if (xhr.responseJSON && xhr.responseJSON.validation_errors) {
            $(':input', form).removeClass(errorClass);
            $.each(xhr.responseJSON.validation_errors, (name) => {
              const element = form.find('[name="' + name + '"]');
              element.addClass(errorClass);
              if (name === 'sec') {
                aponeo.refreshCaptcha();
              }
            });
          } else if (xhr.responseJSON && xhr.responseJSON.messages) {
            $('#rating-modal').modal('hide');
            aponeo.addNotificationList(result.messages);
            modal.modal('hide');
            window.scrollTo(0, $('#notification-lines').position().top);
          } else {
            aponeo.addNotification(
              'Beim Bewerten dieses Produkts ist ein Fehler aufgetreten. <br> Bitte versuchen Sie es später erneut.',
              1,
            );
            modal.modal('hide');
            window.scrollTo(0, $('#notification-lines').position().top);
          }
        })
        .always(() => {
          aponeo.hideLoadingScreen();
        });
    });
    // rating modal form
    $('.btn-rating-submit').on('click', (event) => {
      const element = $(event.target);
      const form = element.closest('form');
      const modal = $('#rating-modal');
      const errorClass = 'is-invalid';

      $.ajax({
        type: 'POST',
        url: '/rpc.php?action=addProductRating',
        data: form.serialize(),
        beforeSend: () => {
          aponeo.showLoadingScreen();
        },
      })
        .done((result) => {
          // close modal
          modal.modal('hide');
          aponeo.refreshCaptcha();
          if (!result.messages) {
            return;
          }
          aponeo.addNotificationList(result.messages);
          window.scrollTo(0, $('#notification-lines').position().top);
        })
        .fail((xhr) => {
          if (xhr.responseJSON && xhr.responseJSON.validation_errors) {
            $(':input', form).removeClass(errorClass);
            $.each(xhr.responseJSON.validation_errors, (name) => {
              const element = form.find('[name="' + name + '"]');
              element.addClass(errorClass);
              if (name === 'sec') {
                aponeo.refreshCaptcha();
              }
            });
          } else if (xhr.responseJSON && xhr.responseJSON.messages) {
            modal.modal('hide');
            for (let i = 0, length = xhr.responseJSON.messages.length; i < length; i++) {
              const msgData = xhr.responseJSON.messages[i];
              aponeo.addNotification(msgData[0], msgData[1]);
            }
            window.scrollTo(0, $('#notification-lines').position().top);
          } else {
            modal.modal('hide');
            aponeo.addNotification(
              'Beim Bewerten dieses Produkts ist ein Fehler aufgetreten. <br> Bitte versuchen Sie es später erneut.',
              1,
            );
            window.scrollTo(0, $('#notification-lines').position().top);
          }
        })
        .always(() => {
          aponeo.hideLoadingScreen();
        });
    });
  }
};
